import { AccountInfo } from "@azure/msal-browser";
import { useQuery } from "@tanstack/react-query";
import { oneDriveService } from "../services/oneDriveService";

/**
 * React Query hook for fetching OneDrive app folder URL.
 * Uses infinite cache since the URL never changes.
 *
 * @param account - MSAL account to use for API calls
 * @returns Query result with app folder web URL
 */
export const useAppFolderUrl = (account: AccountInfo | null) => {
  return useQuery({
    queryKey: ["onedrive", "appFolderUrl", account?.homeAccountId],
    queryFn: async () => {
      if (!account) throw new Error("Account required");
      const url = await oneDriveService.getAppFolderUrl(account);
      return url;
    },
    staleTime: Infinity, // URL never changes
    gcTime: Infinity, // Keep in cache forever
    retry: 2,
    enabled: !!account,
  });
};
